import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import React from "react";
import { POLICY_CONTENT_SECTION } from "../../../util/constants";
import { classes, StyledSectionWrapper } from "./styles";

const Content = () => {
  return (
    <StyledSectionWrapper sectionId={POLICY_CONTENT_SECTION}>
      <Container>
        <div className={classes.wrapper}>
          <Typography variant="body2" gutterBottom>
            <section>
              <p>Cette politique est établie conformément :</p>

              <ul>
                <li>
                  au{" "}
                  <strong>
                    Règlement Général sur la Protection des Données (RGPD)
                  </strong>
                  , entré en vigueur le 25 mai 2018.
                </li>
                <li>
                  à la <strong>loi Informatique et Libertés</strong> modifiée,
                  initialement adoptée le 6 janvier 1978 et mise à jour
                  notamment par la loi du 20 juin 2018 et l’ordonnance du 12
                  décembre 2018.
                </li>
              </ul>

              <p>
                Elle vous informe sur la manière dont Innovance collecte,
                utilise et protège vos données personnelles.
              </p>
            </section>
            <section>
              <span style={{ textDecoration: "underline" }}>
                1. Identité du responsable du traitement
              </span>

              <ul>
                <strong>Innovance</strong>
                <br />
                SIRET : 51814705300046
                <br />
                Adresse : 10 chemin du Maquis – 74000 ANNECY
                <br />
                Téléphone : 04 50 10 61 37
                <br />
                Contact :{" "}
                <a href="mailto:webmaster@innovance-solutions.fr">
                  webmaster@innovance-solutions.fr
                </a>
              </ul>
            </section>
            <section>
              <span style={{ textDecoration: "underline" }}>
                2. Données personnelles collectées
              </span>
              <ul>
                <li>Nom, prénom</li>
                <li>Nom de l'organisme</li>
                <li>Téléphone</li>
                <li>Adresse e-mail</li>
                <li>Adresse IP</li>
                <li>
                  Données de navigation (pages visitées, temps passé, etc.)
                </li>
              </ul>
            </section>
            <section>
              <span style={{ textDecoration: "underline" }}>
                3. Finalité du traitement
              </span>
              <ul>
                <li>
                  Les données du formulaire de contact sont utilisées à des fins{" "}
                  <strong>d'information</strong> et de{" "}
                  <strong>prospection commerciale.</strong>
                </li>
                <li>Les données de navigation sont utilisées :</li>
                <li>
                  pour produire des{" "}
                  <strong>statistiques de fréquentation du site,</strong>
                </li>
                <li>
                  pour mesurer la{" "}
                  <strong>conversion des annonces publicitaires</strong>{" "}
                  Innovance diffusées sur <strong>LinkedIn</strong>.
                </li>
              </ul>
            </section>
            <section>
              <span style={{ textDecoration: "underline" }}>
                4. Base légale du traitement
              </span>
              <ul>
                <li>
                  Les données du formulaire sont traitées sur la base du{" "}
                  <strong>consentement</strong> explicite de l’utilisateur.
                </li>
                <li>
                  Le dépôt et la lecture des traceurs de mesure d’audience
                  Google Analytics et de mesure des campagnes LinkedIn reposent
                  sur votre <strong>consentement préalable</strong>. Aucun de
                  ces traceurs n’est déclenché avant votre accord.
                </li>
                <li>
                  La mémorisation de votre choix est strictement nécessaire au
                  fonctionnement du gestionnaire de préférences.
                </li>
              </ul>
            </section>
            <section>
              <span style={{ textDecoration: "underline" }}>
                5. Duree de conservation
              </span>
              <ul>
                <li>
                  Données de contact : <strong>5 ans</strong> à compter de la
                  dernière interaction avec Innovance.
                </li>
                <li>
                  Données de navigation : <strong>26 mois</strong> maximum.
                </li>
                <li>
                  Choix relatif aux traceurs : <strong>6 mois</strong> avant
                  qu’il vous soit demandé à nouveau.
                </li>
              </ul>
            </section>
            <section>
              <span style={{ textDecoration: "underline" }}>
                6. Destination des données
              </span>
              <ul>
                <li>
                  Les données de navigation sont traitées via{" "}
                  <strong>Google Analytics</strong> et <strong>LinkedIn</strong>
                  .
                </li>
                <li>
                  Les données du formulaire sont hébergées sur les serveurs de{" "}
                  <strong>Netlify</strong>.
                </li>
                <li>
                  Les données de contacts peuvent être stockées dans la base de
                  contacts d'Innovance via <strong>Avizi Apps Atlas CRM</strong>
                  .
                </li>
                <li>
                  Sur accord explicite, les données de contact peuvent être
                  réutilisées pour des campagnes d’emailing via{" "}
                  <strong>Mailjet</strong>.
                </li>
              </ul>
            </section>
            <section>
              <span style={{ textDecoration: "underline" }}>
                7. Transferts hors Union Européenne
              </span>
              <p>
                Les données collectées sont transférées vers des pays hors Union
                Européenne via :
              </p>
              <ul>
                <li>
                  <strong>Netlify</strong> (États-Unis)
                </li>
                <li>
                  <strong>Google Analytics</strong> (États-Unis)
                </li>
                <li>
                  <strong>LinkedIn</strong> (États-Unis)
                </li>
              </ul>
            </section>
            <section>
              <span style={{ textDecoration: "underline" }}>
                8. Sécurité des données
              </span>
              <p>
                Innovance et ses fournisseurs mettent en œuvre des mesures
                techniques et organisationnelles pour assurer la sécurité des
                données :
              </p>
              <ul>
                <li>Chiffrement des données en transit et au repos</li>
                <li>Accès restreint aux données</li>
                <li>
                  Traitement des données de navigation via{" "}
                  <strong>Google Analytics</strong> (
                  <a
                    href="https://support.google.com/analytics/answer/6004245?hl=fr"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    voir la politique de sécurité de Google Analytics
                  </a>
                  )
                </li>
                <li>
                  Mesure de conversion des annonces publicitaires{" "}
                  <strong>LinkedIn</strong> (
                  <a
                    href="https://www.linkedin.com/legal/privacy-policy?_l=fr_FR"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    voir la politique de confidentialité de LinkedIn{" "}
                  </a>
                  )
                </li>
                <li>
                  Hébergement des données de contacts via{" "}
                  <strong>Netlify</strong> (
                  <a
                    href="https://www.netlify.com/security"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    voir la politique de sécurité de Netlify
                  </a>
                  )
                </li>
              </ul>
            </section>
            <section>
              <span style={{ textDecoration: "underline" }}>
                9. Droits des utilisateurs
              </span>
              <p>
                Conformément à la réglementation, vous disposez des droits
                suivants :
              </p>
              <ul>
                <li>Droit d’accès à vos données personnelles</li>
                <li>Droit de rectification</li>
                <li>Droit à l'effacement</li>
                <li>Droit de limitation du traitement</li>
                <li>
                  Droit d’opposition, y compris à la prospection commerciale par
                  email ou via LinkedIn
                </li>
                <li>Droit à la portabilité</li>
                <li>Droit de retirer votre consentement à tout moment</li>
              </ul>
              <p>
                Pour exercer vos droits, contactez <strong>Innovance</strong>{" "}
                par email :{" "}
                <a href="mailto:webmaster@innovance-solutions.fr">
                  webmaster@innovance-solutions.fr
                </a>
              </p>
            </section>
            <section>
              <span style={{ textDecoration: "underline" }}>
                10. Collecte via LinkedIn Lead Gen Ads
              </span>
              <p>
                Innovance diffuse ponctuellement des annonces contenant des
                formulaires Leads Gen via LinkedIn :
              </p>
              <ul>
                <li>
                  <strong>Données collectées</strong> : Nom, prénom, fonction,
                  nom de l’organisme, email, téléphone.
                </li>
                <li>
                  <strong>Finalité</strong> : prospection commerciale et suivi
                  des demandes.
                </li>
                <li>
                  <strong>Base légale</strong> : consentement explicite via
                  cases à cocher; finalité également affichée sur le formulaire.
                </li>
                <li>
                  <strong>Destinataires</strong> : LinkedIn et Innovance.
                </li>
                <li>
                  <strong>Durée de conservation</strong> :
                  <ul>
                    <li>12 mois maximum chez LinkedIn,</li>
                    <li>
                      5 ans à compter de la dernière interaction avec Innovance
                      pour les contacts transférés dans le CRM.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Exercice des droits</strong> :{" "}
                  <a href="mailto:webmaster@innovance-solutions.fr">
                    webmaster@innovance-solutions.fr
                  </a>{" "}
                  ou via LinkedIn.
                </li>
              </ul>
              <p>
                Les utilisateurs sont invités à consulter la politique de
                confidentialité de LinkedIn pour plus d’informations sur le
                traitement de leurs données : <br />
                <a
                  href="https://www.linkedin.com/legal/privacy-policy?_l=fr_FR"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.linkedin.com/legal/privacy-policy?_l=fr_FR
                </a>
              </p>
            </section>
            <section>
              <span style={{ textDecoration: "underline" }}>11. Cookies</span>
              <p>
                Le site distingue les traceurs strictement nécessaires des
                traceurs soumis à votre consentement :
              </p>
              <ul>
                <li>
                  <strong>Nécessaires</strong> : mémorisation de vos préférences
                  de confidentialité ; ils sont toujours actifs.
                </li>
                <li>
                  <strong>Mesure d’audience</strong> : Google Analytics 4,
                  déclenché uniquement après votre accord.
                </li>
                <li>
                  <strong>Mesure des campagnes</strong> : LinkedIn Insight,
                  déclenché uniquement après votre accord.
                </li>
                <li>
                  <strong>Contenus externes</strong> : YouTube, chargé
                  uniquement après votre accord.
                </li>
              </ul>
              <p>
                Lors de votre première visite, vous pouvez tout accepter, tout
                refuser ou choisir chaque finalité. Vous pouvez retirer votre
                accord à tout moment depuis le lien « Gérer mes cookies »
                présent dans le pied de page.
              </p>
            </section>
            <section>
              <span style={{ textDecoration: "underline" }}>
                12. Modification de la politique de confidentialité
              </span>
              <p>
                Cette politique est susceptible d’être modifiée. Nous vous
                invitons à la consulter régulièrement. <br />
                <br />
                <strong>Date de dernière mise à jour : 17 août 2026.</strong>
              </p>
            </section>
          </Typography>
        </div>
      </Container>
    </StyledSectionWrapper>
  );
};

export default Content;
